export default {
  landingPageFiltersClear: {
    id: 'landing-page_filters_clear',
    defaultMessage: 'Clear all filters',
  },
  landingPageFiltersProductsNew: {
    id: 'landing_page_filters_products_new_plural',
    defaultMessage: `{total, plural,
      one {# product}
      other {# products}
    }`,
  },
  price: {
    id: 'landing_price_filter_title',
    defaultMessage: 'Price',
  },
}
